import React from 'react';
import ReactDOM from 'react-dom';
import { Analytics } from '@vercel/analytics/react';

import App from "./components/app";
import reportWebVitals from './reportWebVitals';
import {sendToVercelAnalytics} from './vitals';

import './index.css';

import { Provider } from "react-redux";
import { store } from "./store/store";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App/>
      <Analytics/>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals(sendToVercelAnalytics);
